module.exports = __webpack_public_path__ + "static/media/Ellipse.27d2d0c4.png";